export const TYPE_SERP_LOAD_MORE = 'serp-load-more'
